import { usePortfolioStore } from "@/stores/usePortfolioStore";

// useFacilityStore is a thin selector over usePortfolioStore.
// All facility data is fetched via hydrateFacility (usePortfolioStore.load) —
// no separate GET /facilities/{id} call is made.
export const useFacilityStore = <T>(selector: (s: {
  facilityId: string | null;
  facility: import("@/pages/facility/facility.types").FacilityInfo | null;
  loading: boolean;
  error: string;
  load: (id: string) => Promise<void>;
  refresh: (id: string) => Promise<void>;
  reset: () => void;
}) => T): T =>
  usePortfolioStore((s) => selector({
    facilityId: s.facilityId,
    facility: s.facility,
    loading: s.loading,
    error: s.error,
    load: s.load,
    refresh: s.refresh,
    reset: s.reset,
  }));

// getState() compatibility for imperative access
useFacilityStore.getState = () => {
  const s = usePortfolioStore.getState();
  return {
    facilityId: s.facilityId,
    facility: s.facility,
    loading: s.loading,
    error: s.error,
    load: s.load,
    refresh: s.refresh,
    reset: s.reset,
  };
};
